.container {
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
}

.popover {
  max-width: 500px;
}
